export const siteConfig = {
  name: '黑料社网',
  slogan: '专题合集 · 精选盘点',
  positioning: '把零散热点整理成能一次看完的合集',
  description:
    '黑料社网是一个以专题合集与精选盘点为核心的内容门户，把网络热点、娱乐话题、流行梗与名场面按主题归类，配上分类榜单，方便快速浏览，省去逐个查找的时间。',
  email: 'hello@heiliaoshe.example.com',
  cooperateEmail: 'partner@heiliaoshe.example.com',
  since: '2021',
};

export const categories: { key: string; name: string; desc: string; icon: string }[] = [
  { key: 'all', name: '全部专题', desc: '所有已上线的合集与盘点', icon: 'ri-apps-2-line' },
  { key: 'hotsearch', name: '热搜盘点', desc: '一段时间里被反复提起的瞬间', icon: 'ri-fire-line' },
  { key: 'entertain', name: '娱乐观察', desc: '综艺、影视与内容人的高光回顾', icon: 'ri-movie-2-line' },
  { key: 'network', name: '网络话题', desc: '热梗、争议与舆论场的形成过程', icon: 'ri-chat-3-line' },
  { key: 'scene', name: '影像现场', desc: '出圈镜头背后的城市与人', icon: 'ri-camera-lens-line' },
  { key: 'culture', name: '文化盘点', desc: '创意、国潮与流行文化的样本', icon: 'ri-book-2-line' },
];

export const faqs: { q: string; a: string }[] = [
  {
    q: '黑料社网的专题合集是怎么整理的？',
    a: '我们按主题把同一类热点归拢到一个专题里，每个专题都标注了分类、更新时间和条目数量。你不需要逐个去翻，进一个专题就能把相关的瞬间一次性看完。',
  },
  {
    q: '分类榜单和专题合集有什么区别？',
    a: '专题合集强调「归类」，把同类内容装进同一个主题；分类榜单强调「排序」，按热度、讨论量或时间把条目排成名次。两者互为补充，前者便于系统浏览，后者便于快速抓重点。',
  },
  {
    q: '专题会持续更新吗？',
    a: '会。热门专题会随事件进展补充新的条目，专题页会显示最近更新时间。已经收官的盘点则会标记为「已完结」，方便你回头查阅。',
  },
  {
    q: '网站内容可以转载吗？',
    a: '站内整理的专题结构与榜单为原创编排，欢迎在注明来源并保留链接的前提下引用。由第三方提供口径的数据，我们会尽量标注出处。',
  },
  {
    q: '如何推荐一个值得做的专题？',
    a: '可以通过「关于我们」页面里的联系方式把想法发给我们，写清楚主题、大致包含的条目范围和它值得被整理的原因，我们会评估是否立项。',
  },
];

export const subscriptions = {
  formId: 'daii60joh653ivfvods0',
  submitAddr: 'https://readdy.ai/api/form/daii60joh653ivfvods0',
};